module.exports = __webpack_public_path__ + "static/media/output.c90b0c0d.png";